import { create, node } from '@dojo/framework/core/vdom';
const factory = create({ node });
export const cssProperty = factory(({ middleware: { node } }) => {
    return {
        get(key, prop) {
            const domNode = key === ':root' ? document.documentElement : node.get(key);
            if (!domNode) {
                return undefined;
            }
            return getComputedStyle(domNode).getPropertyValue(prop);
        },
        set(key, prop, value) {
            const domNode = key === ':root' ? document.documentElement : node.get(key);
            if (!domNode) {
                return false;
            }
            domNode.style.setProperty(prop, value);
            return true;
        }
    };
});
